<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-content>
            <md-table
              md-fixed-header
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar>
                <md-field>
                  <label for="contractors">Per page</label>
                  <md-select v-model="pagination.perPage" name="contractors">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>

                <md-field>
                  <md-button
                    style="margin-bottom : 7px; background-color: rgb(31, 71, 154) !important;"
                    class="md-primary md-round md-small"
                    @click="newWorkType()"
                    >Add a new Category</md-button
                  >
                </md-field>
              </md-table-toolbar>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name" md-sort-by="name">{{
                  item.name
                }}</md-table-cell>
                <md-table-cell md-label="Category">
                  <template v-if="item.activity_types.activity">
                    Things to do
                  </template>
                  <template v-if="item.activity_types.dining">
                    Things to eat
                  </template>
                </md-table-cell>
                <md-table-cell md-label="Edit">
                  <md-button
                    class="md-just-icon md-warning md-simple"
                    @click.native="handleEdit(item)"
                  >
                    <md-icon>edit</md-icon>
                  </md-button>
                </md-table-cell>
                <md-table-cell md-label="Delete">
                  <md-button
                    class="md-just-icon md-danger md-simple"
                    @click.native="handleDelete(item)"
                  >
                    <md-icon style="color: rgb(31, 71, 154) !important"
                      >close</md-icon
                    >
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></pagination>
          </md-card-actions>
        </md-card>
      </div>
    </div>

    <popup :save="true" :error="error" :loading="loading">
      <h3 v-if="!work_type.name">Add a Category</h3>
      <h3 class="head-stat" v-else>
        {{ work_type.name }}
        <span>{{ getClicks }}</span>
        <span>{{ clicks }} <span class="clicks">clicks</span></span>
      </h3>
      <div class="inputs">
        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Name</label>
            <md-input v-model="work_type.name" type="text"></md-input>
            <span class="md-helper-text">Required</span>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Type</label>
            <select v-model="type">
              <option value="activity">Things to Do</option>
              <option value="dining">Things to Eat</option>
            </select>
            <!-- <md-select v-model="work_type.type">
            <md-option value="Exterior">Exterior</md-option>
            <md-option value="Interior">Interior</md-option>
            <md-option value="Both">Both</md-option>
          </md-select> -->
            <span class="md-helper-text">Required</span>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Parent Category</label>
            <select v-model="work_type.parent_category">
              <option :value="null">None</option>
              <option v-for="item in tableData" :value="item.name">{{
                item.name
              }}</option>
            </select>
          </md-field>
        </div>
        <!-- <div class="md-layout-item md-size-100">
        <div class="input">
          <label>Image</label>
          <upload
            title="Work Type Icon"
            :media="work_type.icon"
            @addMedia="addMedia($event, 'url')"
            @removeMedia="removeMedia()"
            @removeImage="advertisement.event_image = null"
          ></upload>
          <span class="md-helper-text">Required</span>
        </div>
      </div> -->
      </div>
    </popup>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Popup from "@/components/Popup.vue";
import Fuse from "fuse.js";
import { db } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import Upload from "@/components/Upload.vue";

export default {
  components: {
    Pagination,
    popup: Popup,
    upload: Upload
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    getClicks() {
      db.collection("preset_user_menus")
        .doc("service_menu")
        .collection("services")
        .doc(this.work_type.name)
        .collection("clicks")
        .get()
        .then(snapshot => {
          console.log(snapshot.docs.length);
          this.clicks = snapshot.docs.length;
        });
    },
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      type: null,
      error: null,
      loading: false,
      work_type: {
        name: null,
        slug: null,
        activity_types: {
          activity: false,
          dining: false
        },
        parent_category: null
      },
      showPopup: false,
      currentSort: "name",
      currentSortOrder: "asc",
      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [100, 200],
        total: 0
      },
      footerTable: ["Icon", "Slug", "Name", "Description", "Edit", "Delete"],
      searchQuery: "",
      propsToSearch: ["description", "last_signal", "slug"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      clicks: null
    };
  },
  firestore() {
    return {
      tableData: db
        .collection("preset_user_menus")
        .doc("service_menu")
        .collection("services")
    };
  },
  methods: {
    newWorkType() {
      this.work_type = {
        name: null,
        slug: null,
        activity_types: {
          activity: false,
          dining: false
        }
      };
      this.showPopup = true;
    },
    save() {
      if (this.validate()) {
        if (!this.work_type.slug) {
          let name = this.work_type.name
            .split(" ")
            .join("")
            .toLowerCase();
          this.work_type.slug = this.type + "_" + name;
        }
        this.work_type[this.type] = true;
        console.log(this.work_type);
        db.collection("preset_user_menus")
          .doc("service_menu")
          .collection("services")
          .doc(this.work_type.name)
          .set(this.work_type, { merge: true })
          .then(() => {
            this.type = null;
            this.loading = false;
            this.showPopup = false;
          });
      }
    },
    validate() {
      this.error = null;
      this.loading = true;
      let valid = true;
      for (let key in this.work_type) {
        if (
          !this.work_type[key] &&
          key != "activity_types" &&
          key != "slug" &&
          key != "parent_category"
        ) {
          valid = false;
        }
      }
      if (!valid) {
        this.error = "Please enter all fields!";
        this.loading = false;
      }
      return valid;
    },
    addMedia(url, key) {
      this.work_type.icon = url;
    },
    removeMedia() {
      this.work_type.icon = null;
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleEdit(item) {
      this.work_type = item;
      this.showPopup = true;
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          return db
            .collection("preset_user_menus")
            .doc("service_menu")
            .collection("services")
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire("Deleted!", "The item has been deleted.", "success");
            });
        }
      });
    }
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "url"],
      threshold: 0.3
    });
  },
  watch: {
    type() {
      this.work_type.activity_types[this.type] = true;
    },
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.popup h3 {
  font-weight: bold;
  margin-top: 0;
}

.head-stat {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
}

.head-stat span {
  font-weight: normal;
}

.head-stat span .clicks {
  font-size: 13px;
  opacity: .5;
  margin-left: -5px;
}
</style>
